import { useEffect, useState } from 'react';
import Bowser from 'bowser';
import Dialog from '../Journal/Dialog';
import Button from '../Button';
import { eventType, Mixpanel } from '../../utils/mixpanel';

export default function UnsupportedBrowserWarning() {
  const [blocked, setBlocked] = useState(false);

  useEffect(() => {
    const browser = Bowser.getParser(window.navigator.userAgent);
    const isValidBrowser = browser.satisfies({
      chrome: '>130.0.6723.69',
      edge: '>130.0.2849.68',
      firefox: '>131.0',
      safari: '>=18.1'
    });

    setBlocked(!isValidBrowser);
  }, []);

  const handleClose = () => {
    setBlocked(false);
    Mixpanel.track(eventType.closeUnsupportedBrowserWarning);
  };

  return (
    <Dialog
      isOpen={blocked}
      title="Din webbläsare stöds inte"
      onClose={() => {}}
      type="danger"
      actions={<Button onClick={handleClose}>OK</Button>}
      nonDismissable
    >
      <p>Clinic fungerar bäst med någon av följande webbläsare.</p>
      <ul className="disc-list">
        <li>Google Chrome: 130.0.6723.69</li>
        <li>Microsoft Edge: 130.0.2849.68</li>
        <li>Mozilla Firefox: 131.0</li>
        <li>Apple Safari: 18.1</li>
      </ul>
      <p>Vänligen uppdatera din webbläsare, eller byt till någon av de som listas ovan.</p>
    </Dialog>
  );
}
